import React, { useRef } from "react";
import "./carousel-desk.scss";
import ShowContainer from "../ShowContainer.jsx";
import CarouselDeskHeader from "./carousel_desk_header/CarouselDeskHeader.jsx";
import useGetItems from "../../../hooks/other/useGetItems.js";
import CustomCarousel from "../custom-carousel/CustomCarousel.jsx";

export default function CarouselDesk({ isRow2, items = [], title, children, showAllLink = "" }) {
  const sliderRef = useRef(null);
  const slidesToShow = useGetItems();

  const manyLength = items.length > slidesToShow;

  return (
    <ShowContainer condition={items.length}>
      <div className="carousel-desk">
        <CarouselDeskHeader
          title={title}
          showAllLink={showAllLink}
          sliderRef={sliderRef}
          manyLength={manyLength}
          slidesToShow={slidesToShow}
        />
        {manyLength ? (
          <CustomCarousel
            ref={sliderRef}
            onSwiper={(e) => (sliderRef.current = e)}
            className="carousel-desk__items"
            initialSlide={0}
            spaceBetween={10}
            speed={1000}
            loop={true}
            autoplay={false}
            allowTouchMove={true}
            slidesPerView={slidesToShow}
            // slidesPerGroup={slidesToShow}
            pagination={false}>
            {React.Children.map(children, (child, indx) => {
              if (isRow2) return children;

              return (
                <div key={indx} className="carousel-item" data-index={indx}>
                  {child}
                </div>
              );
            })}
          </CustomCarousel>
        ) : (
          <div className={`carousel-desk__items carousel-plug carousel-plug-${slidesToShow}`}>
            {children}
          </div>
        )}
      </div>
    </ShowContainer>
  );
}
